import classes from "./Title.module.css";
import Logo from "../assets/logos/codeweblogofeb23.png";
import { Link } from "react-router-dom";
// Imports for the burger menu
// import React from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "../global";
import { theme } from "../theme";
import Burger from "./burger/Burger";
import Menu from "./menu/Menu";
import { useOnClickOutside } from "../hooks/onClickOutside";
import React, { useState, useRef, useEffect } from "react";

function Title() {
  const [open, setOpen] = useState(false);
  const [width, setWindowWidth] = useState(0);

  const node = useRef();
  useOnClickOutside(node, () => setOpen(false));

  // this deletes text on certain width
  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
  };

  return (
    <div className={classes.title}>
      <div className={classes.login}>
        <button className={classes["login-button"]}>
          <Link to="/login">
            <strong>Log in</strong>
          </Link>
        </button>
      </div>
      <img className={classes["header-logo"]} src={Logo} alt="Logo" />
      {/* This is the mobile burger menu */}
      {width < 450 && (
        <div className={classes.burger}>
          <ThemeProvider theme={theme}>
            <>
              <GlobalStyles />
              <div className={classes.burger} ref={node}>
                <Burger open={open} setOpen={setOpen} />
                <Menu open={open} setOpen={setOpen} />
              </div>
            </>
          </ThemeProvider>
        </div>
      )}
      {width > 450 && (
        <div className={classes['empty-div']}>
          
        </div>
      )}
    </div>
  );
}

export default Title;
